import { http } from "../../../common/http";

export const getTypeList = () => {
    return http({
        method: 'GET',
        url: '/type'
    });
}

export const getTypeDetail = (id: number) => {
    return http({
        url: `/type/${id}`,
        method: "GET"
    })
}